import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=3c8d8496&"
import script from "./UserSelect.vue?vue&type=script&lang=js&"
export * from "./UserSelect.vue?vue&type=script&lang=js&"
import style0 from "./UserSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../data/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c8d8496')) {
      api.createRecord('3c8d8496', component.options)
    } else {
      api.reload('3c8d8496', component.options)
    }
    module.hot.accept("./UserSelect.vue?vue&type=template&id=3c8d8496&", function () {
      api.rerender('3c8d8496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/Forms/Fields/UserSelect.vue"
export default component.exports